import { render, staticRenderFns } from "./heads.vue?vue&type=template&id=d4f9b938"
import script from "./heads.vue?vue&type=script&lang=js"
export * from "./heads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports